export default __webpack_public_path__ + "static/media/tick.cc04434c.webp";